export function validateBasics(state, t) {
  const errors = {};
  if (!state.campaignName) {
    errors.campaignName = t("This is a mandatory field");
  }
  if (!state.jobPostingUrl) {
    errors.jobPostingUrl = t("This is a mandatory field");
  } else if (!isValidURL(state.jobPostingUrl)) {
    errors.jobPostingUrl = t("Please put in a valid URL");
  }
  return errors;
}

export function validateLocation(state, t) {
  const errors = {};
  if (!state.locations?.length) {
    errors.locations = t("This is a mandatory field");
  }
  return errors;
}

export function hasErrors(errors) {
  return !!Object.values(errors || {}).filter(Boolean).length;
}

function isValidURL(value) {
  let url;

  try {
    url = new URL("/", value);
  } catch (error) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}
